import { render, staticRenderFns } from "./IdeasoftKategori.vue?vue&type=template&id=cceb5636&scoped=true"
import script from "./IdeasoftKategori.vue?vue&type=script&lang=js"
export * from "./IdeasoftKategori.vue?vue&type=script&lang=js"
import style0 from "./IdeasoftKategori.vue?vue&type=style&index=0&id=cceb5636&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cceb5636",
  null
  
)

export default component.exports